// extracted by mini-css-extract-plugin
export default {"section":"Footer_section__WY7UZ","iconBox":"Footer_iconBox__JwlBN","copirate":"Footer_copirate__bnuje","icon":"Footer_icon__ctCoM"};